import React, { useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const s = {
  page: { minHeight:'100vh', background:'var(--paper)', display:'flex', alignItems:'center', justifyContent:'center', padding:24 },
  card: { background:'var(--card)', border:'1px solid var(--line-card)', borderRadius:0, width:'100%', maxWidth:420, overflow:'hidden' },
  header: { background:'var(--ink)', padding:'28px 32px' },
  brand: { fontFamily:'var(--font-display)', color:'var(--paper)', fontSize:20 },
  body: { padding:'32px' },
  title: { fontFamily:'var(--font-display)', fontSize:20, fontWeight:700, marginBottom:6, color:'var(--ink)' },
  sub: { color:'var(--muted)', fontSize:13, marginBottom:24 },
  label: { display:'block', fontSize:11, fontFamily:'var(--font-mono)', letterSpacing:'1px', marginBottom:6, textTransform:'uppercase', color:'var(--muted-2)' },
  input: { width:'100%', padding:'11px 14px', border:'1px solid var(--line)', borderRadius:0, fontSize:14, outline:'none', fontFamily:'var(--font-body)', marginBottom:16, background:'var(--card)' },
  btn: { width:'100%', background:'var(--ink)', color:'var(--paper)', border:'none', padding:'13px', fontSize:15, fontWeight:600, borderRadius:0, cursor:'pointer' },
  error: { background:'var(--card)', border:'1px solid var(--danger)', color:'var(--danger)', padding:'10px 14px', borderRadius:0, fontSize:13, marginBottom:16 }
};

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [form, setForm] = useState({ password: '', confirm: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirm) return setError('Passwords do not match');
    if (form.password.length < 6) return setError('Password must be at least 6 characters');
    setLoading(true);
    try {
      await axios.post(`/api/auth/reset-password/${token}`, { password: form.password });
      navigate('/login', { state: { message: 'Password reset successfully. Please sign in.' } });
    } catch (err) {
      setError(err.response?.data?.message || 'Reset failed. Link may have expired.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={s.page}>
      <div style={s.card} className="fade-in">
        <div style={s.header}><div style={s.brand}>BioMedArticles</div></div>
        <div style={s.body}>
          <h2 style={s.title}>New password</h2>
          <p style={s.sub}>Choose a new password for your account.</p>
          {error && <div style={s.error}>{error}</div>}
          <form onSubmit={handleSubmit}>
            <label style={s.label}>New Password</label>
            <input style={s.input} type="password" value={form.password} onChange={e => setForm({...form, password: e.target.value})} placeholder="Min. 6 characters" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            <label style={s.label}>Confirm Password</label>
            <input style={s.input} type="password" value={form.confirm} onChange={e => setForm({...form, confirm: e.target.value})} placeholder="Repeat password" required onFocus={e => e.target.style.borderColor='var(--ink)'} onBlur={e => e.target.style.borderColor='var(--line)'} />
            <button style={{ ...s.btn, opacity: loading ? 0.7 : 1 }} type="submit" disabled={loading}>
              {loading ? 'Resetting...' : 'Reset Password →'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
